import $ from 'jquery';
import { getParams } from './util/urlParam';
import { exhibitioninfo, langList } from './variables';
import { emailValidation_single, passwordValidation_single } from './util/validation';
import translate, { Lang, t } from './util/translate';
import { loginJqXHR } from './api';
import { setCookie} from './util/cookie';

$(() => {
  // ローカルストレージ非対応環境
  if (!window.localStorage) {
    alert("お使いのブラウザは対応してません。Chromeなどの他ブラウザをご利用ください。");
  }

  translate(); // 翻訳

  // クエリ取得
  const params = getParams(exhibitioninfo);

  // 言語設定 クエリ優先 -> localStorage
  let lang = 'ja' as keyof Lang
  if (langList.indexOf(String(params.lang)) !== -1) {
    lang = params.lang as keyof Lang;
    localStorage.setItem('lang', lang);
  }else{
    lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
  }

  // ログインボタンクリック
  $('#loginBtn').on('click', () => {
    // バリデーションチェック
    let forms = document.getElementsByClassName('needs-validation');
    Array.prototype.filter.call(forms, function (form) {
      // メールアドレスのチェック
      //emailValidation_single(form.email);
      // パスワードのチェック
      //passwordValidation_single(form.password);
      if (form.checkValidity() === false) {
        // エラー表示
        form.classList.add('was-validated');
        const firstelement = document.querySelector<HTMLElement>('input:invalid');
        if (firstelement) firstelement.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        // ログイン処理
        loginJqXHR(form.email.value, form.password.value)
          .done(function (data1, textStatus, jqXHR) {
            if (data1.type == 'success') {
              setCookie("loginToken",data1.token);
              let path = getRedirectUri(location.search)
              if(path[0]) {
                location.href = path[1] as string;
              } else {
                location.href = '../../index.html'
              }
            };
          }).fail(function (jqXHR, textStatus, errorThrown) {
            if( jqXHR.responseJSON.msg == "事務局の承認をお待ちしてください。" ){
              $('.js-login-error').text(t.lg_err1[lang]);
              $('.js-login-error').show();
            } else {
              $('.js-login-error').text(t.lg_err2[lang]);
              $('.js-login-error').show();
            }
          });
      }
    });
  });
  /**
   * クエリパラメータから'rediirect_uri'を取得
   */
  let getRedirectUri = function getRedirectUri(query : string) {
    let urlflg = false;
    let url = "";
    let query_sp = query.substring(1).split('&');
    let params = query_sp[0].split('=');
    if( params[0] === 'redirect_uri' ){
      urlflg = true;
      url = params[1];
    }
    return [urlflg, decodeURIComponent(url)];
  };

  // フッター問い合わせ
  let contactlist: string = 
  `
  <dd><span>`+ t.footer_tigs[lang] + t.footertel_tigs[lang] +`</span> <a href="mailto:`+ t.footermail_tigs[lang] +`">`+ t.footermail_tigs[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_ld[lang] + t.footertel_ld[lang] +`</span> <a href="mailto:`+ t.footermail_ld[lang] +`">`+ t.footermail_ld[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_landd[lang] + t.footertel_landd[lang] +`</span> <a href="mailto:`+ t.footermail_landd[lang] +`">`+ t.footermail_landd[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_gds[lang] + t.footertel_gds[lang] +`</span> <a href="mailto:`+ t.footermail_gds[lang] +`">`+ t.footermail_gds[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_pi[lang] + t.footertel_pi[lang] +`</span> <a href="mailto:`+ t.footermail_pi[lang] +`">`+ t.footermail_pi[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_osaka[lang] + t.footertel_osaka[lang] +`</span> <a href="mailto:`+ t.footermail_osaka[lang] +`">`+ t.footermail_osaka[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_fukuoka[lang] + t.footertel_fukuoka[lang] +`</span> <a href="mailto:`+ t.footermail_fukuoka[lang] +`">`+ t.footermail_fukuoka[lang] +`</a>)</dd>
  `
  $('#box_officework').html(contactlist);

  translate(); // 翻訳

});

